import { useTranslation } from 'react-i18next';
import {
  Modal,
  Button,
  Text,
  DescriptionList
} from '@efast_public/fjd-component-library';
import { OnlinedienstTemplate } from '../api/govos.types';

interface MarketplaceOdInformationModalProps {
  isOpen: boolean;
  onClose: () => void;
  template: OnlinedienstTemplate;
}

export function MarketplaceOdInformationModal({
  isOpen,
  onClose,
  template
}: MarketplaceOdInformationModalProps) {
  const { t } = useTranslation();

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Modal.Header id="modal-header">
        <Text size="xl" strong>
          {t('MarketplaceOdInformationModal.title')}
        </Text>
      </Modal.Header>
      <Modal.Content>
        <div style={{ marginBottom: '24px' }}>
          <Text
            size="xl"
            strong
            style={{ display: 'block', marginBottom: '24px' }}
          >
            {template.title}
          </Text>
          <DescriptionList hasDivider>
            <DescriptionList.Item
              title={t('MarketplaceOdInformationModal.fields.version')}
              description={template.version}
            />
            <DescriptionList.Item
              title={t('MarketplaceOdInformationModal.fields.ozgLeistung')}
              description={
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '4px'
                  }}
                >
                  <Text>{template.ozg?.id || '-'}</Text>
                  {template.ozg?.name && (
                    <Text variant="secondary">{template.ozg.name}</Text>
                  )}
                </div>
              }
            />
            <DescriptionList.Item
              title={t('MarketplaceOdInformationModal.fields.leikaLeistungen')}
              description={
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px'
                  }}
                >
                  {template.leika && template.leika.length > 0 ? (
                    template.leika.map((leika, index) => (
                      <div
                        key={index}
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: '4px'
                        }}
                      >
                        <Text>{leika.id}</Text>
                        <Text variant="secondary">{leika.name}</Text>
                      </div>
                    ))
                  ) : (
                    <Text>-</Text>
                  )}
                </div>
              }
            />
          </DescriptionList>
        </div>
      </Modal.Content>
      <Modal.Footer>
        <Button variant="primary" onClick={onClose} style={{ width: '100%' }}>
          {t('MarketplaceOdInformationModal.actions.close')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
